import {
	Home,
	Compass,
	MessageSquare,
	User,
	Search,
	Settings,
} from 'lucide-react'
import { Link, Outlet } from 'react-router'

import { Button } from '#app/components/ui/button.tsx'

const navItems = [
	{ icon: Home, label: 'Home', to: '/home' },
	{ icon: Search, label: 'Search', to: '/search' },
	{ icon: Compass, label: 'Explore', to: '/explore' },
	{ icon: MessageSquare, label: 'Messages', to: '/messages' },
	{ icon: User, label: 'Profile', to: '/p/distro' },
]

export default function HubLayout() {
	return (
		<div className="relative flex flex-col md:flex-row">
			<Sidenav />
			<div className="flex-1 overflow-y-scroll">
				<Outlet />
			</div>
		</div>
	)
}

function Sidenav() {
	return (
		<div className="sticky top-0 hidden h-screen w-64 flex-col gap-y-6 bg-neutral-950 p-8 text-neutral-400 md:flex">
			<Link to="/" className="mb-6 flex items-center gap-3 tracking-wide">
				<img src="/img/logo-white.svg" className="h-6 w-6" /> Intermave
			</Link>
			{navItems.map(({ icon: Icon, label, to }) => (
				<Link to={to} key={label} className="flex items-center gap-3">
					<Icon className="h-5 w-5" /> {label}
				</Link>
			))}
			<div className="flex-1" />
			<Button variant="outline" className="w-full text-primary">
				+ Create goal
			</Button>
			<Link to="/settings" className="flex items-center gap-3">
				<Settings className="h-5 w-5" /> Settings
			</Link>
		</div>
	)
}
